// extracted by mini-css-extract-plugin
module.exports = {"page":"Home_page__1DCkO","head":"Home_head__3foNb","card":"Home_card__1pTnp","shirt":"Home_shirt__1E32S"};